<template>
    <div @click="$emit('click')">
        <div v-if="isImage"
            class="ts-border ts-p-2 ts-rounded-md ts-w-12 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
            <img :src="readFromUrl" alt="" class="ts-h-full ts-rounded">
        </div>
        <div v-else-if="isPdf"
            class="ts-border ts-p-2 ts-rounded-md ts-w-12 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
            <i class="far fa-file-pdf ts-text-red-600 fa-2x"></i>
        </div>
        <div v-else-if="isExcel"
            class="ts-border ts-p-2 ts-rounded-md ts-w-12 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
            <i class="far fa-file-excel fa-2x ts-text-green-600"></i>
        </div>
        <div v-else-if="isDocument"
            class="ts-border ts-p-2 ts-rounded-md ts-w-12 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
            <i class="far fa-file-word fa-2x ts-text-blue-600"></i>
        </div>
        <div v-else="unknowFile"
            class="ts-border ts-p-2 ts-rounded-md ts-w-12 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
            <i class="far fa-file-alt fa-2x ts-text-blue-600"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'fileViewer',
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    computed: {
        readFromUrl() {
            if (this.resource.file instanceof File) {
                return URL.createObjectURL(this.resource.file);
            }
            return this.resource.storage_path
        },
        isImage() {
            return this.resource.type.includes('image')
        },
        isPdf() {
            return this.resource.type.includes('application/pdf')
        },
        isExcel() {
            return this.resource.type.includes('spreadsheetml')
        },
        isDocument() {
            return this.resource.type.includes('officedocument')
        }
    }
}
</script>